import styled from 'styled-components';
import Box from '../layout/Box';
var FocusTrap = styled(Box).attrs(function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as;
  return {
    tabIndex: -1,
    as: as,
    className: 'focus-trap'
  };
}).withConfig({
  displayName: "FocusTrap",
  componentId: "sc-l88i15-0"
})(["display:inherit;outline:none;"]);
FocusTrap.displayName = 'FocusTrap';
export default FocusTrap;